//through@2 handles this by default!
module.exports = require('through')




//////////////////
// WEBPACK FOOTER
// ./node_modules/pause-stream/index.js
// module id = 799
// module chunks = 0